export default __webpack_public_path__ + "static/media/checkbox-active.4a40082c.svg";